// extracted by mini-css-extract-plugin
module.exports = {"textCenter":"Footer_textCenter__2cBOM"};